import { IHttpApi } from '@cian/http-api/shared';
import { trackComplaintSend } from '../components/Complaint';
import { getBrowserFingerprint } from '../utils/fingerprint';
import { getCreateComplaintMarkup, EComplaintState } from '../repositories/moderation-complaints/v2/create-complaint';
import { getAddFeedbackRequestMarkup } from '../repositories/moderation-complaints/v1/add-feedback-request';
import { IComplaint } from '../types/complain';

/* istanbul ignore next */
export function createGetComplaints(httpApi: IHttpApi) {
  return (categoryId: number, regionId?: number | null) => {
    // Технический долг, будет убран в https://cianru.atlassian.net/browse/CD-41841
    return httpApi
      .fetch(
        {
          apiType: 'public',
          assertStatusCodes: [200],
          method: 'GET',
          microserviceName: 'moderationComplaints',
          parameters: {
            categoryId,
            regionId,
          },
          pathApi: '/v2/get-complaint-types/',
        },
        {
          requestConfig: { withCredentials: false },
        },
      )
      .then(res => res.response as IComplaint[]);
  };
}

/* istanbul ignore next */
export function createSendComplaint(httpApi: IHttpApi) {
  return (offerId: number, complaintId: string, message?: string) => {
    // Технический долг, будет убран в https://cianru.atlassian.net/browse/CD-41841
    return getCreateComplaintMarkup({
      httpApi,
      parameters: {
        complaintOnSiteId: complaintId,
        message,
        userContextInfo: {
          uniqueId: getBrowserFingerprint(),
        },
        realtyObjectId: offerId,
        complaintState: EComplaintState.New,
      },
      config: {
        requestConfig: {
          withCredentials: true,
          headers: [['Content-Type', 'application/json']],
        },
      },
      // tslint:disable-next-line: no-any
    }).then(({ response }) => {
      trackComplaintSend();

      return response as { complaintId: number; getUserFeedback: boolean };
    });
  };
}

/* istanbul ignore next */
export function createSendFeedback(httpApi: IHttpApi) {
  return (email: string, complaintId: number) => {
    return getAddFeedbackRequestMarkup({
      httpApi,
      parameters: {
        complaintId,
        email,
      },
      config: {
        requestConfig: {
          withCredentials: false,
          headers: [['Content-Type', 'application/json']],
        },
      },
    });
  };
}
